"use client";

import { cn } from "@/lib/utils";

const PARTICLES = [
  { left: "8%", top: "14%", size: 10, color: "white", delay: 0, duration: 26 },
  { left: "22%", top: "68%", size: 14, color: "green", delay: 2, duration: 32 },
  { left: "38%", top: "28%", size: 8, color: "gold", delay: 4, duration: 28 },
  { left: "52%", top: "78%", size: 12, color: "white", delay: 1, duration: 30 },
  { left: "67%", top: "18%", size: 9, color: "green", delay: 3, duration: 24 },
  { left: "78%", top: "52%", size: 16, color: "gold", delay: 5, duration: 34 },
  { left: "88%", top: "32%", size: 7, color: "white", delay: 2.5, duration: 27 },
  { left: "15%", top: "42%", size: 11, color: "gold", delay: 1.5, duration: 29 },
  { left: "44%", top: "58%", size: 6, color: "green", delay: 3.5, duration: 25 },
  { left: "91%", top: "72%", size: 13, color: "white", delay: 4.5, duration: 31 },
  { left: "58%", top: "12%", size: 8, color: "gold", delay: 0.5, duration: 28 },
  { left: "32%", top: "86%", size: 10, color: "green", delay: 2.8, duration: 33 },
] as const;

const COLOR_MAP = {
  white: "bg-white/10",
  green: "bg-[#4CAF50]/10",
  gold: "bg-[#f4c95d]/12",
} as const;

interface HeroParticlesProps {
  enabled?: boolean;
}

export function HeroParticles({ enabled = true }: HeroParticlesProps) {
  if (!enabled) return null;

  return (
    <div
      className="pointer-events-none absolute inset-0 z-[1] overflow-hidden"
      aria-hidden
    >
      {PARTICLES.map((particle, index) => (
        <span
          key={index}
          className={cn(
            "hero-particle absolute rounded-full blur-[1px]",
            COLOR_MAP[particle.color]
          )}
          style={{
            left: particle.left,
            top: particle.top,
            width: particle.size,
            height: particle.size,
            animationDelay: `${particle.delay}s`,
            animationDuration: `${particle.duration}s`,
          }}
        />
      ))}
    </div>
  );
}
